import { render, staticRenderFns } from "./NotAllowedTooltip.vue?vue&type=template&id=51e5bb20&scoped=true&"
import script from "./NotAllowedTooltip.vue?vue&type=script&lang=js&"
export * from "./NotAllowedTooltip.vue?vue&type=script&lang=js&"
import style0 from "./NotAllowedTooltip.vue?vue&type=style&index=0&id=51e5bb20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e5bb20",
  null
  
)

export default component.exports